import pckg from '../../package.json'
import { debugMessage } from '../common'
import { clearTelemetryCache } from './chartDataCache'

export const APP_VERSION_STORAGE_KEY = 'p3portal-app-version'

function readStoredAppVersion() {
  try {
    return window.localStorage.getItem(APP_VERSION_STORAGE_KEY)
  } catch (_) {
    return null
  }
}

function writeStoredAppVersion(version) {
  try {
    window.localStorage.setItem(APP_VERSION_STORAGE_KEY, version)
  } catch (_) {}
}

/** Wipe IndexedDB telemetry when package.json version differs from localStorage. */
export async function clearTelemetryCacheIfAppVersionChanged() {
  const currentVersion = pckg.version
  const storedVersion = readStoredAppVersion()

  if (storedVersion === currentVersion) return

  debugMessage(
    `App version ${storedVersion || 'none'} → ${currentVersion}, clearing telemetry cache`,
    'appVersion'
  )
  await clearTelemetryCache()
  writeStoredAppVersion(currentVersion)
}
